<template>
<b-row class="mapContent">
    <div class="login boxLogin">
      <b-row class="mtop10 mbottom10" v-if="typeMap === 'geo'">
        <vue-google-autocomplete
          id="map"
          classname="form-control"
          placeholder="Start typing your address"
          v-on:placechanged="getAddressData">
        </vue-google-autocomplete>
      </b-row>
    <l-map :zoom="zoom" ref="map" :bounds="bounds" style="height:75vh;max-height:300px;">>
        <l-tile-layer :url="url"></l-tile-layer>
        <l-marker v-for="item in markers" :key="item.id" :lat-lng="item.position" @click="info($event,item)" :draggable="item.draggable" @dragend="dragEnd($event, item)">
            <l-popup>
                <b-list-group></b-list-group>
            </l-popup>
        </l-marker>
    </l-map>
    <b-row class="mtop10 center" v-if="typeMap === 'geo'">
      <!-- Use this location / Use navitagtor location -->
      <!-- <button @click="currentLocation">{{ $t("messages.useNavigatorLocation") }}</button> -->
      <button @click="useLocation" :disabled="addressData === null">{{ $t("messages.useLocation") }}</button>
    </b-row>
    <b-row class="mtop10 center" v-if="showEdit">
      <div class="menuTopCont center mauto pbottom0">
        <router-link class="btn btnBg center" :to="`/pool-detail/${poolId}`"> {{ $t("messages.poolInfoEdit") }}</router-link>
      </div>
    </b-row>

    </div>
</b-row>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {
    LMap,
    LTileLayer,
    LPopup,
    LMarker
} from "vue2-leaflet";


export default {
    components: {
        LMap,
        LTileLayer,
        LPopup,
        LMarker,
        VueGoogleAutocomplete
    },
    props: {
        initialPos: {},
        type: '',
        isNew: false,
        poolId:null,
        showEdit:false
    },
    data: function () {
        return {
            url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
            zoom: 1,
            map: null,
            mapLayer: null,
            markers: [],
            bounds: {},
            coordinates: {},
            isLoading: true,
            addressData:null,
            typeMap:null
        };
    },
    created() {
      try{
        this.typeMap = this.type;
        this.setMarker(this.initialPos.position);
      } catch(err){
        
      }
        
    },
    watch: {
        'initialPos': {
            handler(value) {
            this.setMarker(this.initialPos.position);
            },
            deep: true
        }
    },
        
    methods: {
      dragEnd(item) {
        try{
          this.addressData.lat = item.target._latlng.lat
          this.addressData.lng = item.target._latlng.lng
        }catch(error){
          console.log('not valid coords');
        }
      },
      currentLocation() {
          this.$getLocation().then(coordinates => {
            if(!this.addressData) this.addressData = {};
            Object.assign(this.addressData, coordinates);
            this.setMarker(coordinates)
          });
      },

      useLocation() {
        this.$emit('onSaveLocation', this.addressData);
      },

      getAddressData: function (response, placeResultData, id) {
        this.response = response;

        let address = {
          city: response.locality,
          street :  response.route.concat((response.street_number !== undefined) ? ','+response.street_number : ''),
          zipcode: response.postal_code,
          lat: response.latitude,
          lng: response.longitude
        }
        if(!this.addressData) this.addressData = {};
        this.addressData = address;
        let coords ={
          lat: response.latitude,
          lng: response.longitude
        }
        this.setMarker(coords)
      },

      setMarker(coordinates) {
        try{
          if(coordinates.lat!="0" && coordinates.lng!="0"){
            this.markers = []
            let coords = [];
            this.markers.push({
                position: coordinates,
                clickable: false,
                draggable: true
            });
            coords.push([coordinates.lat, coordinates.lng]);
            this.zoom = 17
            this.bounds = L.latLngBounds(coords);
            this.coordinates = coordinates
            this.isLoading = false;
          }
          
        } catch(error) {
          // Not valid coordinates
          console.log('not valid coordinates');
        }
      }
    }
};
</script>

<style scoped>
  .loadingAlpha {
      opacity: 0.5;
  }

  .loading {
      opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Map-geo.vue